// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".money-input[data-v-4f33b32d] {\n  max-width: 2em;\n}", ""]);
// Exports
module.exports = exports;
